/* eslint-disable jira/filename-case */

import type { PreloadedQuery } from 'react-relay';
import type { DisposeFn, OperationType } from 'relay-runtime';
import type { Route } from '@atlassian/react-resource-router';
import { useLastLoadedRoute } from '../store/getEntryPointsStore.tsx';

export const useRouteEntryPoint = ({
	route,
}: {
	route: Route;
}): Readonly<{
	dispose: DisposeFn;
	entryPoints: {
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		[x: string]: Readonly<any>;
	};
	extraProps: {} | null;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	getComponent: () => any;
	isDisposed: boolean;
	queries: {
		[x: string]: PreloadedQuery<OperationType, Record<string, unknown>>;
	};
	rootModuleID: string;
}> | null => {
	const [lastLoadedRoute] = useLastLoadedRoute();

	// route.entryPoint is already loaded
	if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) {
		return lastLoadedRoute.entryPointReference;
	}

	return null;
};
